{
  "Repo": "https://lba-consulting@dev.azure.com/lba-consulting/Abercrombie%20and%20Kent/_git/AK%20Frontend%20Reservation",
  "LastCommitHash": "be5ebac447c5559bd952f0c8441e440c6333b540",
  "LastCommitMessage": "Merge branch uat_price-setup-changes into dev-update-version19",
  "LastCommitAuthor": "roberto.dipiano",
  "LastCommitTime": "Thu Nov 5 17:06:14 2026 +0100",
  "VersionNumber": "22067"
}